// eslint-disable-next-line no-shadow
var CustomerOrigin;
(function (CustomerOrigin) {
    CustomerOrigin["NONE"] = "NONE";
    CustomerOrigin["ECOMMERCE"] = "ECOMMERCE";
    CustomerOrigin["MANAGER"] = "MANAGER";
})(CustomerOrigin || (CustomerOrigin = {}));

export { CustomerOrigin };
//# sourceMappingURL=customerOrigin.js.map
